export default __webpack_public_path__ + "ea5e24d5acfc9feba22b62af3acd46da.svg";